import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalSettingsService } from '../../services/global-settings.service';
import { FilteredViewService } from '../../services/filtered-view.service';
import { environment } from '../../../../environments/environment';

@Injectable()
export class FilteredViewInterceptor implements HttpInterceptor {
  constructor(
    private globalSettingsService: GlobalSettingsService,
    private filteredViewService: FilteredViewService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (
      this.globalSettingsService.isFilteredView() &&
      request.url.indexOf(environment.USER_BASE) < 0
    ) {
      // tslint:disable-next-line:max-line-length
      const headers = request.headers.set(
        this.globalSettingsService.getTrackerTokenName(),
        this.globalSettingsService.getTrackerTokenValue(),
      );
      request = request.clone({
        headers,
      });
    }
    return next.handle(request);
  }
}
